import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import MaterialTable from "../../Components/Table/MaterialTable";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { tableEye } from "../../common/Assets/imgs";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";

const HelpSupport = () => {
  const navigation = useNavigate();
  const [adminList, setAdminList] = useState([]);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(1);
  const [loader, setLoader] = useState(false);

  const [status, setStatus] = useState("pending");
  // const pendingData = [
  //   {
  //     sno: "01",
  //     transportId: "KD075821",
  //     transportName: "Swift way Transports",
  //     amount: "₹35500",
  //   },
  //   {
  //     sno: "02",
  //     transportId: "KD075822",
  //     transportName: "Blue Route Logistics",
  //     amount: "₹65550",
  //   },
  //   {
  //     sno: "03",
  //     transportId: "KD075823",
  //     transportName: "Khyathi Movers",
  //     amount: "₹87550",
  //   },
  // ];

  // const completedData = [
  //   {
  //     sno: "01",
  //     transactionName: "Khyathi Logistics",
  //     transportName: "Swift way Transports",
  //     amount: "₹35500",
  //     dateTime: "10-12-2025, 1:00 PM",
  //   },
  //   {
  //     sno: "02",
  //     transactionName: "Khyathi Logistics",
  //     transportName: "Blue Route Logistics",
  //     amount: "₹65550",
  //     dateTime: "10-12-2025, 1:00 PM",
  //   },
  //   {
  //     sno: "03",
  //     transactionName: "Khyathi Logistics",
  //     transportName: "Khyathi Movers",
  //     amount: "₹87550",
  //     dateTime: "10-12-2025, 1:00 PM",
  //   },
  // ];
  const pageSize = 10;
  const pendingColumns = [
    {
      header: "S.No",
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      // accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey:"user_code",
      header:"User ID",
    },
    { accessorKey: "user_name", header: "User Name" },
    { accessorKey: "user_type", header: "User Type" },
    // {
    //   accessorKey: "amount",
    //   header: "Amount",
    //   Cell: ({ cell }) => (
    //     <span style={{ color: "green", fontWeight: 600 }}>
    //       {cell.getValue()}
    //     </span>
    //   ),
    // },
    {
      accessorKey: "date_time",
      header: "Date & Time",
    },
    {
      accessorKey: "status",
      header: "Status",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          // <div className={`${value === "Active" ? 'statusactive' : 'statusdeactive'}`} >
          <span
            className={
              value === "Pending" ? "status-inactive" : "status-active"
            }
          >
            {value === "Pending" ? "Pending" : "Resolved"}
            {/* {value} */}
          </span>
          // </div>
        );
      },
    },
    {
      id: "action",
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() => {
            navigation("/help-view", {
              state: {
                data: row.original,
                type: "view",
                // Status: "pending",
              },
              //   state: "pending",
            });
          }}
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  // const completedColumns = [
  //   {
  //     header: "S.No",
  //     accessorFn: (row, index) => index + 1,
  //     id: "serial_no",
  //   },
  //   { accessorKey: "user_name", header: "User Name" },
  //   { accessorKey: "user_type", header: "User Type" },
  //   // {
  //   //   accessorKey: "amount",
  //   //   header: "Amount",
  //   //   Cell: ({ cell }) => (
  //   //     <span style={{ color: "green", fontWeight: 600 }}>
  //   //       {cell.getValue()}
  //   //     </span>
  //   //   ),
  //   // },
  //   { accessorKey: "date_Time", header: "Date & Time" },
  //   {
  //     accessorKey: "status",
  //     header: "Status",
  //     Cell: ({ cell }) => {
  //       const value = cell.getValue();
  //       return (
  //         // <div className={`${value === "Active" ? 'statusactive' : 'statusdeactive'}`} >
  //         <span
  //           className={value === "Active" ? "status-active" : "status-inactive"}
  //         >
  //           {value === "Active" ? "pending" : "completed"}
  //         </span>
  //         // </div>
  //       );
  //     },
  //   },
  //   {
  //     id: "action",
  //     header: "Action",
  //     Cell: ({ row }) => (
  //       <div
  //         onClick={() =>
  //           navigation("/help-view", {
  //             state: {
  //               data: row.original,
  //               type: "view",
  //               Status: "resolved",
  //             },
  //           })
  //         }
  //       >
  //         <img src={tableEye} alt="" className="tableeye" />
  //       </div>
  //     ),
  //   },
  // ];

  //   const tableData = status === "pending" ? pendingData : completedData;
  // const tableColumns = status === "pending" ? pendingColumns : completedColumns;

  //   const filteredData = adminList.filter((item) =>
  //   status === "pending"
  //     ? item.status === "pending"
  //     : item.status === "completed"
  // );
  console.log("adminList", adminList);

  //  const filteredData = adminList.filter((item) => item.status === status);

  const getList = async (src, page) => {
    try {
      setLoader(true);
      const res = await get(`${URLS.HELP_LIST}?search=${src}&page=${page}`);
      console.log("res", res);
      if (res?.status === "success") {
        const filterdata = res?.data.filter(
          (item) => item?.status === "Resolved",
        );

          const filterdataa = res?.data.filter(
          (item) => item?.status === "Pending",
        );

        const fildata = status === "completed" ? filterdata : filterdataa;

        setAdminList(fildata);
        setLoader(false);
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    getList(search, pagination);
  }, [status, search, pagination]);
  return (
    <div>
      <Header title={"Help & Support"} />
      <div className="container-fluid main-container">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          {/* LEFT TITLE */}
          <div>
            <h3 className="m-0 fw-bold fs-5 text-black">Help & Support</h3>

            {/* ADD BUTTON */}

            <button
              onClick={() => setStatus("pending")}
              style={{ backgroundColor: status === "pending" ? "#F98425" : "" }}
              className={`btn fw-semibold px-4 py-2 mt-2 ${status === "pending" ? "text-white" : "border text-warning border-warning"}`}
            >
              Pending
            </button>
            <button
              onClick={() => setStatus("completed")}
              style={{
                backgroundColor: status === "completed" ? "#F98425" : "",
              }}
              className={`btn  fw-semibold px-4 py-2 ms-4 mt-2 ${status === "completed" ? "text-white" : "border text-warning border-warning"}`}
            >
              Resolved
            </button>
          </div>

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">
            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3">
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-none bg-transparent"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="ms-2 searchdote">|</div>
              <FaSearch color="#7A52AB" className="ms-1" />
            </div>
          </div>
        </div>
        <MaterialTable
          columns={pendingColumns}
          // columns={tableColumns}
          data={adminList || []}
          pagination={pagination}
          setPagination={setPagination}
          loading={loader}
        />
      </div>
    </div>
  );
};

export default HelpSupport;
